













import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { BaseStore, KfDataType } from '@/store/modules/Base'
import { loadCustomService } from '@/api/user'

@Component({
  name: 'QRcode'
})
export default class QRcode extends Vue {
  @Prop({
    type: Boolean,
    default: false
  }) value!: boolean

  private get kfData (): KfDataType {
    return BaseStore.kfData
  }

  get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  get dialogVisible (): boolean {
    return this.value
  }

  set dialogVisible (newData) {
    this.handleValue(newData)
  }

  @Emit('input')
  handleValue (newData) {
    return newData
  }

  getLoadCustomService () {
    const params = {
      custServiceId: this.userInfo.customServiceId
    }
    loadCustomService(params)
      .then(res => {
        if (res.success) {
          BaseStore.SET_SERVICE(res.data)
        }
      })
  }

  mounted ():void {
    this.getLoadCustomService()
  }
}

